import { useMutation } from '@tanstack/react-query';

import { useMemo } from 'react';
import { showToast } from '@/services/toast-service';
import { createPayout } from '@/services/coloc-api/admin';
import { useGetPayoutSummaryContext } from '../use-get-payout-summary';
import { BASE_URL } from '@/config';

const useCreatePayout = () => {
  const { passedRentIds } = useGetPayoutSummaryContext()!;

  const passedRentIdsAsObjects: Array<{ rent_id: number }> = useMemo(() => {
    const rentIDArray = passedRentIds.split(',').map((rentId) => {
      return { rent_id: Number(rentId.trim()) };
    });
    return rentIDArray;
  }, [passedRentIds]);

  const mutate = useMutation({
    mutationKey: ['createPayout'],
    mutationFn: () => {
      return createPayout({
        items: passedRentIdsAsObjects,
      });
    },
    onSuccess: (data) => {
      window.location.replace(`${BASE_URL}/admin/new-rents`);
    },
    onError: (response) => {
      showToast.error({
        title: 'Failed to create payout',
        text: response.response.data.error,
      });
    },
  });

  return {
    mutate,
  };
};

export { useCreatePayout };
